import React, { Component } from 'react';

import { Button } from 'components/button';
import { Grid } from 'components/grid';
import { InfoTooltip } from 'components/tooltip';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import PagesContentService from './PagesContentService';

import DeepSearchSelect from '../commons/DeepSearchSelect';

export default class PagesContentOptions extends Component {
  static propTypes = {
    t: PropTypes.func,
    onMenuOpen: PropTypes.func,
    clearAllCheckedItems: PropTypes.func,
    concludedValue: PropTypes.object,
    setConcluded: PropTypes.func,
    confirmSelectedItems: PropTypes.func,
    isButtonDisabled: PropTypes.func,
    isOpen: PropTypes.bool
  };

  render() {
    const {
      clearAllCheckedItems,
      onMenuOpen,
      concludedValue,
      setConcluded,
      confirmSelectedItems,
      isButtonDisabled,
      isOpen
    } = this.props;

    return (
      <Grid className="access__select__grid__container access__select__grid__clean">
        <div className="access__select__footer__options">
          <div className="access__select__footer__options__input">
            <InfoTooltip
              rerenderPosition
              text="users_manager.deep_search.content.pages_tooltip"
              className="pages__content__tooltip"
            />
            <DeepSearchSelect
              name={name}
              onMenuOpen={onMenuOpen}
              value={concludedValue}
              options={PagesContentService.concludedOptions()}
              setValueSelect={setConcluded}
              isOpen={isOpen}
              placeholder="users_manager.deep_search.content.concluded_placeholder"
            />
          </div>
          <div className="access__select__footer__options__actions">
            <Button type="cancel" size="small" onClick={clearAllCheckedItems}>
              <I18n label="general.clean" />
            </Button>
            <Button
              size="medium"
              outline
              className="access__select__clean__button"
              onClick={confirmSelectedItems}
              disabled={isButtonDisabled}
            >
              <I18n label="general.ok" />
            </Button>
          </div>
        </div>
      </Grid>
    );
  }
}
